(ns motorsaif.shared.events
  (:require
   [meta-merge.core :as mm]
   [motorsaif.shared.interceptors :as ic]
   [motorsaif.sente :as sente]
   [motorsaif.log :as log]
   [motorsaif.version :as ver :refer [version]]
   [motorsaif.shared.interceptors :as fx]
   [taoensso.encore :as encore]
   [motorsaif.time :as time]
   [motorsaif.data-utils :as du]
   [motorsaif.url :as url]
   ;; [ajax.easy]
   [re-frame.core :as rf]))

(defn vec->db-id-map [coll]
  (reduce
   (fn [acc itm]
     (assoc acc
            (:db/id itm)
            (-> itm
                (du/update-if-exists :db/id #(if (vector? %)
                                               (with-meta % {:replace true}) %))
                (du/update-if-exists :responses #(with-meta % {:replace true}))
                (du/update-if-exists :short/prefix+id #(with-meta % {:replace true}))
                (du/update-if-exists :messages #(with-meta % {:replace true}))
                (du/update-if-exists :thread-id #(with-meta % {:replace true}))
                (du/update-if-exists :thread #(with-meta % {:replace true}))
                (du/update-if-exists :touched/topic #(if (vector? %)
                                                       (with-meta % {:replace true}) %))
                (du/update-if-exists :touched/by+topic #(with-meta % {:replace true}))
                (du/update-if-exists :request/category #(with-meta % {:replace true}))
                (du/update-if-exists :business/coords #(with-meta % {:replace true}))
                (du/update-if-exists :request/media #(with-meta % {:replace true}))
                (du/update-if-exists :request/coords #(with-meta % {:replace true}))
                (du/update-if-exists :webpush #(with-meta % {:replace true}))
                (du/update-if-exists :profile #(with-meta % {:replace true}))
                (du/update-if-exists :business/media #(with-meta % {:replace true}))
                (du/update-if-exists :business/misc #(with-meta % {:replace true}))
                (du/update-if-exists :roles #(with-meta % {:replace true}))
                (du/update-if-exists :unique-responders-with-last-sent #(with-meta % {:replace true}))
                (du/update-if-exists :unique-business-seen #(with-meta % {:replace true})))))
   {}
   coll))

(defn assoc-db-id-coll [db [k coll]]
  (let [k-vec (if (vector? k)
                k
                [k])]
    (assoc-in db k-vec (vec->db-id-map coll))))

(defn merge-db-id-coll [db [k coll]]
  (let [k-vec (if (vector? k)
                k
                [k])]
    ;; TODO what is this first clause for?
    ;; use spy?
    (if (map? coll)
      (assoc-in db (conj k-vec (:db/id coll)) coll)
      (update-in db k-vec #(mm/meta-merge % (vec->db-id-map coll))))))

(rf/reg-event-db :assoc-request-db-data
  (fn [db [_ k request]]
    (let [{:keys [_success data]} request]
      (assoc-db-id-coll db [k data]))))

(rf/reg-event-db :assoc-data
  (fn [db [_ k data]]
    (if (vector? k)
      (assoc-in db k data)
      (assoc db k data))))

(rf/reg-event-db :update-data
  (fn [db [_ k afn & args]]
    (apply update-in db (du/ensure-vec k) afn args)))

(rf/reg-event-db :merge-db-id-coll
  (fn [db [_ k coll]]
    (merge-db-id-coll db [k coll])))

;; Requests tend to be wrapped in data
(rf/reg-event-db :merge-db-id-data
  (fn [db [_ k data]]
    ;; (log/info [:merging k data])
    (merge-db-id-coll db [k (:data data)])))

(def ^:private *bootstrap-queue (atom []))

(defn queue-after-bs [afn]
  (swap! *bootstrap-queue conj afn))

(defn ensure-after-bs [afn]
  (if (= :fetched @(rf/subscribe [:ajax-status :bootstrap-data]))
    (afn)
    (queue-after-bs afn)))

(rf/reg-event-db :set-ui-state
  (fn [db [_ k-path v]]
    (if (fn? v)
      (update-in db (apply conj [:ui-state] (du/ensure-vec k-path)) v)
      (assoc-in db (apply conj [:ui-state] (du/ensure-vec k-path)) v))))

;; This could be a go loop gets started after bootstrap done
(rf/reg-event-fx :consume-bs-queue
  (fn [_ _]
    ;; (log/info "consume bs queue")
    (doseq [afn @*bootstrap-queue]
      (afn))
    (reset! *bootstrap-queue [])
    {}))

(rf/reg-event-db :reset-form
  (fn [db [_ form-key data]]
    (assoc-in db [:forms form-key] data)))

(rf/reg-event-db :set-bootstrap-data
  (fn [db [_ data]]
    (rf/dispatch [:fetch-user-touches])
    (rf/dispatch [:fetch-messages {:status :active}])
    ;; (rf/dispatch [:fetch-user-requests])
    (rf/dispatch [:consume-bs-queue])

    ;; TODO should not need, but getting empty string on mobile app
    (-> (merge db data)
        (assoc-in [:build :version] version)
        (assoc-in [:build :git-hash] (ver/git-hash)))))

(rf/reg-event-fx :reset-requests
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [_ _]
    {:ajax {:type    :GET
            :id      :fetch-requests
            :url     "/api/requests"
            :handler [:assoc-request-db-data :requests]}}))

(rf/reg-event-fx :fetch-requests
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [_ [_ {:keys [request-id status] :as params}]]
    {:ajax {:type    :GET
            :id      :fetch-requests
            :params  params
            :url     "/api/requests"
            :handler [:merge-db-id-data :requests]}}))

(rf/reg-event-fx :fetch-user-requests
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [_ _]
    {:ajax {:type    :GET
            :id      :fetch-requests
            :url     "/api/requests"
            :params  {:data {:user true}}
            :handler [:merge-db-id-data :current-owner-requests]}}))
(comment
  (rf/dispatch [:fetch-requests])
  (rf/dispatch [:fetch-user-requests])
  (rf/dispatch [:bootstrap-data]))

(def ^:private *timeout (atom nil))
(rf/reg-event-db :typing-status
  (fn [db [_ {:keys [thread-id from-id]}]]
    (let [path [:typing-status thread-id from-id]
          ?time (get-in db path)
          now (time/stamp)]
      ;; NOTE: naive
      ;;
      (when (> (- now ?time) (encore/ms :secs 2))
        (when @*timeout (js/clearTimeout @*timeout))
        (reset! *timeout
                (js/setTimeout (fn []
                                 (js/clearTimeout @*timeout)
                                 (reset! *timeout nil)
                                 (rf/dispatch [:assoc-data [:typing-status thread-id] nil]))
                               4000)))
      (assoc-in db path now))))

(rf/reg-event-fx :do-ajax
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [cofx [_ ajax-map]]
    {:ajax ajax-map}))

(rf/reg-event-fx :fetch-threads-meta
  [fx/require-user
   ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [_ [_ {:keys [callback status]}]]
    {:ajax {:type :GET
            :id   :threads-meta
            :params {:status status}
            :url "/api/threads-meta"
            :handler
            (fn [{:keys [data]}]
              (when callback
                (callback))
              (doall (map (fn [[k v]]
                            (rf/dispatch [:merge-db-id-coll k v])) data)))}}))

(rf/reg-event-fx :fetch-threads
  [fx/require-user
   ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [_ [_ {:keys [callback status] :as args}]]
    (assert (#{:active :expired :resolved} status))
    {:ajax {:type :GET
            :id   (keyword :threads status)
            :params {:status status}
            :url "/api/threads"
            :handler
            (fn [{:keys [data]}]
              (when callback
                (callback))
              (rf/dispatch [:assoc-data :threads data]))}}))

(rf/reg-event-fx :fetch-messages
  [fx/require-user]
  (fn [{:keys [db] :as cofx} [_ {:keys [thread-id
                                        status] :as args}]]
    (let [?thread (get-in db [:threads thread-id])]
      {:dispatch-n
       (-> [[:fetch-threads args]]
           (cond-> (not ?thread)
             (conj [:fetch-threads-meta args])))})))

(comment
(rf/dispatch [:fetch-messages :active])
  (doall (map (fn [[k v]]
                (rf/dispatch [:merge-db-id-data k v])
                ) aher))

  (:threads @re-frame.db/app-db)
  (:requester-threads @re-frame.db/app-db)
  (:responder-threads @re-frame.db/app-db)

  (rf/dispatch [:fetch-threads])
  (rf/dispatch [:fetch-threads-meta])
  (rf/dispatch [:fetch-messages {:status :active}]))

(rf/reg-event-db :ws-state
  (fn [db [_ data]]
    (assoc db :ws-state data)))

(rf/reg-event-fx :sente-send
  (fn [cofx [_ event data]]
    (sente/chsk-send! [event data])
    {}))

(rf/reg-event-fx :sente-send-limited
  (fn [cofx [_ event data]]
    (sente/send-limited! [event data])
    {}))

(rf/reg-event-fx :last-seen
  (fn [cofx [_ owner-id]]
    (sente/chsk-send! [:query/last-seen owner-id] 3000
                      (fn [ret]
                        (rf/dispatch [:assoc-data [:last-seen owner-id] ret])))
    {}))

(rf/reg-event-fx :toast
  (fn [db [_ {:keys [title message type id] :as opts}]]
    {:toast opts}))

(rf/reg-event-fx :fetch-businesses
  [ic/trace-fetch-status]
  (fn [_ [_ data]]
    (let [{:keys [_id]} data]
      {:ajax {:type    :GET
              :id      :businesses
              :url     "/api/businesses"
              :handler [:merge-db-id-data :businesses]}})))


(rf/reg-event-fx :fetch-user-touches
  [fx/require-user
   ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [_ _]
    {:ajax {:type :GET
            :id   :touches
            :url  "/api/touch"
            :handler [:merge-db-id-data :touches]}}))

(rf/reg-event-fx :touch-topic
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [_ [_ topic {:keys [role topic-type]}]]
    (assert topic "MISSING TOPIC")
    {:ajax {:type :POST
            :id   :touch-topic
            :params (-> {:topic topic}
                        (du/assoc-if-val :role role)
                        (du/assoc-if-val :topic-type topic-type))
            :url  "/api/touch"
            :handler [:merge-db-id-data :touches]}}))

(rf/reg-event-db :update-thread-touched
  (fn [db [_ touched]]
    (let [{:touched/keys [by topic]} touched
          by-id (:db/id by)]
      ;; (log/info [:touched-update touched])
      (assoc-in db [:threads topic :touches by-id] touched))))

(rf/reg-event-fx :api/request-code
  [ic/trace-fetch-status]
  (fn [_cofx [_ {:keys [email context callback]}]]
    (assert (#{:forgot-password :registration} context))
    {:ajax {:type :POST
            :id :request-code
            :url "/api/account/request-code"
            :params {:data {:email email
                            :context context}}
            :handler (fn [res]
                       (callback res))}}))

(rf/reg-event-fx :api/verify-code
  [ic/trace-fetch-status]
  (fn [_ [_ {:keys [nonce email user] :as params} ?callback]]
    {:ajax {:type    :POST
            :id      :verify-code
            :params  {:data params}
            :url     "/api/account/verify-code"
            :handler (fn [{:keys [success context user state] :as res}]
                       (log/info [:verify-account res])
                       ;; NOTE: Below errors from some fx marshalling step
                       (when ?callback
                         (?callback res))
                       (condp = state
                         :no-user
                         (rf/dispatch [:toast {:type "warn"
                                               :message "Email not found"}])

                         :code-invalid
                         (rf/dispatch [:toast {:type "warn"
                                               :message "Invalid Code"}])

                         :existing-user
                         (rf/dispatch [:toast {:type "success"
                                               :message "Logged in"}])

                         :new-user
                         (rf/dispatch [:toast {:type "success"
                                               :message "Created Account"}])

                         :registration-failed
                         (rf/dispatch [:toast {:type "error"
                                               :message "Registration failed"}])

                         (when user
                           ;; Login user here

                           )))}}))

(rf/reg-event-fx :maps/reverse-geocode
  [ic/trace-fetch-status]
  (fn [_cofx [_ [lat lon] callback]]
    (let [url
          (url/reverse-geocode-url
           "AIzaSyByB4QXFBVCC6eyIzUEhBv3Lm9YMgFBELs" ;; public api key
           {:latitude lat
            :longitude lon})]
      {:ajax {:type :GET
              :id :request-code
              :url url
              :handler (fn [res]
                         (callback
                          {:raw res
                           :addr (get-in (js->clj res) ["results" 0 "formatted_address"])}))}})))

(rf/reg-event-fx :upload-image
  (fn [cofx [_ {:keys [form-data handler error-handler] :as opts}]]
    {:ajax (merge {:type :POST
                   :url "/api/upload"
                   :form-data form-data
                   :timeout-ms (* 1000 60)
                   :id :upload-image
                   :error-handler (fn [] (println "Upload missing error handler"))
                   :handler (fn [] (println "Upload missing handler"))} opts)}))

(rf/reg-event-fx :register-push-sub
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [cofx [_ sub-type {:keys [sub ua]}]]
    (assert (#{:web :mobile} sub-type))
    {:ajax {:type :POST
            :id   :push-sub
            :url  "/api/account/push-sub"
            :params {:sub sub
                     :ua ua
                     :sub-type sub-type}
            :handler
            (fn [{:keys [_success data] :as ret}]
              (rf/dispatch [:assoc-data :clients data]))}}))

(rf/reg-event-fx :delete-push-sub
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [cofx [_ id]]
    {:ajax {:type :DELETE
            :id   :delete-push-sub
            :url  "/api/account/push-sub"
            :params {:client-id id}
            :handler
            (fn [{:keys [success data] :as ret}]
              (log/info [:push-sub ret])
              (rf/dispatch [:assoc-data :clients data]))}}))

(rf/reg-event-fx :message/delete
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [cofx [_ id]]

    {:ajax {:type :DELETE
            :id   :message/delete
            :url  "/api/messages"
            :params {:id id}
            :handler
            (fn [{:keys [success] :as ret}]
              (when success
                (rf/dispatch [:fetch-messages {:status :active}])))}}))

(rf/reg-event-fx :get-interaction-status
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [cofx [_ thread-id]]
    {:ajax {:type :GET
            :id   :get-interaction-status
            :url  "/api/interaction-status"
            :params {:thread-id thread-id}
            :handler
            (fn [{:keys [success data] :as ret}]
              (when success
                (rf/dispatch [:assoc-data [:interaction-status thread-id] data])))}}))

(comment
  (rf/dispatch [:get-interaction-status [1 2]]))

(rf/reg-event-fx :set-interaction-status
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [cofx [_ thread-id label]]
    {:ajax {:type :POST
            :id   :set-interaction-status
            :url  "/api/interaction-status"
            :params {:thread-id thread-id
                     :label label}
            :handler
            (fn [{:keys [success data] :as ret}]
              (when success
                (rf/dispatch [:fetch-messages])
                #_(rf/dispatch [:assoc-data [:interaction-status thread-id] data])))}}))

(comment
  (rf/dispatch [:get-interaction-status [17592186060990 17592186055972]])
  (rf/dispatch [:set-interaction-status [1 2] "yes"]))
